export const INITIAL_STATE = {
    torso: 0,
    neck: 0,
    tail: 0,
    
    leftUpperArm: 0,
    rightUpperArm: 0,
    
    leftLowerArm: 0,
    rightLowerArm: 0,

    rightUpperLeg: 0,
    leftUpperLeg: 0,

    rightLowerLeg: 0,
    leftLowerLeg: 0,
    positionY: 0.65
};

export const WALKING_1 = {
    leftLowerArm: 0,
    leftLowerLeg: 0,
    leftUpperArm: 0.3832138426383452,
    leftUpperLeg: 0.3832138426383452,
    neck: 0,
    rightLowerArm: 0.95,
    rightLowerLeg: 0.95,
    rightUpperArm: -0.9832138426383452,
    rightUpperLeg: -0.9832138426383452,
    tail: 0.4,
    torso: 0,
    positionY: 0.65
}

export const WALKING_2 = {
    leftLowerArm: 0.95,
    leftLowerLeg: 0.95,
    leftUpperArm: -0.9832138426383452,
    leftUpperLeg: -0.9832138426383452,
    neck: 0,
    rightLowerArm: 0,
    rightLowerLeg: 0,
    rightUpperArm: 0.3832138426383452,
    rightUpperLeg: 0.3832138426383452,
    tail: -0.4,
    torso: 0,
    positionY: 0.65
}

export const TAKING_BALL = {
    leftLowerArm: 2.3658038766478366,
    leftLowerLeg: 0.009744729926696394,
    leftUpperArm: -1.5147641297163954,
    leftUpperLeg: -0.5446221281253374,
    neck: 1.1184784460307622,
    rightLowerArm: 2.3658038766478366,
    rightLowerLeg: 0.009744729926696394,
    rightUpperArm: -1.5147641297163954,
    rightUpperLeg: -0.5446221281253374,
    tail: 0,
    torso: 0.7027033024917371,
    positionY: 0.65,
}

export const SIT_DOWN = {
    leftLowerArm: 0,
    leftLowerLeg: 2.0886204476218193,
    leftUpperArm: 0.7027033024917371,
    leftUpperLeg: -1.5147641297163954,
    neck: 0.7027033024917371,
    rightLowerArm: 0,
    rightLowerLeg: 2.0886204476218193,
    rightUpperArm: 0.7027033024917371,
    rightUpperLeg: -1.5147641297163954,
    tail: 0,
    torso: -0.6832138426383452,
    positionY: 0.45,
}